import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f62bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "file-list"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "网址", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "课题", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "作者", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "标签", -1))
const _hoisted_6 = { class: "header-item" }
const _hoisted_7 = { key: 1 }

import { ref, watch } from 'vue'

import DownFileDialog from '@/components/common/DownFileDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResolveUrlList',
  props: {
    resolveData: {}
  },
  setup(__props: any) {

const dialogFormVisible = ref(false)
const dialogTitle = ref('')
const currentUrl = ref('')

const props = __props

const openOriginal = (url: string) => {
  // 提取文件扩展名
  const fileExtension = url.split('.').pop()?.toLowerCase()

  if (!fileExtension) {
    console.error('无法解析文件扩展名')
    return
  }

  // 检查文件扩展名
  if (fileExtension === 'm3u8') {
    currentUrl.value = url
    dialogTitle.value = 'M3U8 文件不能直接下载，请使用支持 M3U8 的播放器观看，或者下载到本地后再观看。'
    dialogFormVisible.value = true
  } else {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

// Watch for changes in resolveData and perform any additional logic if needed
watch(() => props.resolveData, () => {}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.resolveData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_descriptions, {
            column: 1,
            border: "",
            class: "descriptions"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { "label-align": "center" }, {
                label: _withCtx(() => [
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_text, {
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (openOriginal(_ctx.resolveData.url)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.resolveData.url), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { "label-align": "center" }, {
                label: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _createElementVNode("h6", null, _toDisplayString(_ctx.resolveData.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { "label-align": "center" }, {
                label: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.resolveData.author), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { "label-align": "center" }, {
                label: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resolveData.course, (tag, index) => {
                    return (_openBlock(), _createBlock(_component_el_tag, { key: index }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resolveData.fileList, (file, index) => {
            return (_openBlock(), _createBlock(_component_el_card, {
              key: index,
              class: "file-card"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(index + 1) + ". " + _toDisplayString(file.title), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_text, {
                  type: "primary",
                  truncated: "",
                  onClick: ($event: any) => (openOriginal(file.link))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(file.link), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_el_empty, {
            "image-size": 150,
            description: "暂无文件链接"
          })
        ])),
    _createVNode(DownFileDialog, {
      modelValue: dialogFormVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogFormVisible).value = $event)),
      title: dialogTitle.value,
      url: currentUrl.value
    }, null, 8, ["modelValue", "title", "url"])
  ], 64))
}
}

})